/* 🤖 this file was generated by svg-to-ts */
export const IconBigMediumLogout: {
    name: 'big-medium-logout';
    data: string;
} = {
    name: 'big-medium-logout',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M87.91 18.09a5 5 0 1 0-4.29 9 46.17 46.17 0 1 1-65.95 41.75 45.89 45.89 0 0 1 25.93-41.5 5 5 0 0 0-4.39-9A56.17 56.17 0 1 0 120 68.84a56.46 56.46 0 0 0-32.09-50.75"/><path d="M64 93a5 5 0 0 0 5-5V8a5 5 0 0 0-10 0v80a5 5 0 0 0 5 5"/></svg>`,
};
